module.exports = __webpack_public_path__ + "img/s25.910abf9.png";